import { cn } from "@/lib/utils";
import { ReactNode } from "react";
import { useRouterState } from "@tanstack/react-router";

interface PageTransitionProps {
	children: ReactNode;
	className?: string;
}

const PageTransition = ({ children, className }: PageTransitionProps) => {
	const { status } = useRouterState();
	const isLoading = status === "pending";

	return (
		<div
			className={cn(
				"transition-all duration-500 ease-in-out opacity-0 w-full",
				isLoading
					? ""
					: "animate-fadeInOpacity translate-y-0 fill-mode-forwards",
				className,
			)}
		>
			{children}
		</div>
	);
};

export default PageTransition;
